import {Component, HostBinding, HostListener, Input} from '@angular/core';

@Component({
  selector: 'rb-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
})
export class CheckboxComponent {
  @HostBinding('class.checked')
  @Input()
  checked = false;

  @Input()
  disabled = false;
}
